import React, { useState } from "react";
import { useLang } from "../../context/LanguageContext";
import { IMAGES } from "../../lib/constants";
import { Dialog, DialogContent } from "../ui/dialog";
import { X, ChevronLeft, ChevronRight } from "lucide-react";
import { Reveal } from "./Reveal";

const photos = [
  { src: IMAGES.suite1, alt: "Suite maXimo — camera" },
  { src: IMAGES.suite2, alt: "Suite maXimo — camino" },
  { src: IMAGES.suite3, alt: "Suite maXimo — vasca idromassaggio" },
  { src: IMAGES.suite4, alt: "Suite maXimo — dettaglio" },
  { src: IMAGES.room1, alt: "Annette Rooms — camera king" },
  { src: IMAGES.room2, alt: "Annette Rooms — camera matrimoniale" },
  { src: IMAGES.room3, alt: "Annette Rooms — suite king" },
  { src: IMAGES.bath1, alt: "Annette Rooms — bagno moderno" },
  { src: IMAGES.bath2, alt: "Annette Rooms — bagno privato" },
  { src: IMAGES.bath3, alt: "Annette Rooms — dettaglio bagno" },
  { src: IMAGES.sea2, alt: "Porto di Bari Palese" },
  { src: IMAGES.sea1, alt: "Mare di Palese" },
];

export const Gallery = () => {
  const { t } = useLang();
  const [open, setOpen] = useState(false);
  const [index, setIndex] = useState(0);

  const openAt = (i) => {
    setIndex(i);
    setOpen(true);
  };
  const next = () => setIndex((i) => (i + 1) % photos.length);
  const prev = () => setIndex((i) => (i - 1 + photos.length) % photos.length);

  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="relative py-24 md:py-40 bg-[#FDFBF7]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
          <div>
            <Reveal>
              <span className="text-xs uppercase tracking-[0.35em] text-amber-800/80">
                — {t.gallery.overline}
              </span>
            </Reveal>
            <Reveal delay={80}>
              <h2 className="mt-6 font-heading text-5xl md:text-6xl lg:text-7xl leading-[0.98] tracking-tight text-stone-900 max-w-2xl">
                {t.gallery.title}
              </h2>
            </Reveal>
          </div>
          <Reveal delay={140}>
            <p className="max-w-sm text-stone-600 font-light">{t.gallery.description}</p>
          </Reveal>
        </div>

        <div
          className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4"
          data-testid="gallery-grid"
        >
          {photos.map((p, i) => (
            <Reveal key={i} delay={50 * i}>
              <button
                onClick={() => openAt(i)}
                data-testid={`gallery-photo-${i}`}
                className="group relative w-full aspect-square overflow-hidden bg-stone-200 cursor-pointer block"
                aria-label={`Open photo ${i + 1}`}
              >
                <img
                  src={p.src}
                  alt={p.alt}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors" />
                <div className="absolute bottom-3 left-3 right-3 flex items-center justify-between text-white text-[10px] uppercase tracking-[0.2em] opacity-0 group-hover:opacity-100 transition-opacity">
                  <span>{String(i + 1).padStart(2, "0")}</span>
                  <span>View</span>
                </div>
              </button>
            </Reveal>
          ))}
        </div>
      </div>

      {/* Lightbox */}
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent
          className="max-w-6xl w-[95vw] h-[90vh] p-0 bg-black/95 border-none"
          data-testid="lightbox-dialog"
          aria-describedby={undefined}
        >
          <div className="relative w-full h-full flex items-center justify-center">
            <button
              onClick={() => setOpen(false)}
              data-testid="lightbox-close"
              className="absolute top-4 right-4 z-20 w-12 h-12 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full text-white transition-colors"
              aria-label="Close"
            >
              <X className="w-5 h-5" />
            </button>
            <button
              onClick={prev}
              data-testid="lightbox-prev"
              className="absolute left-4 top-1/2 -translate-y-1/2 z-20 w-12 h-12 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full text-white transition-colors"
              aria-label="Previous"
            >
              <ChevronLeft className="w-6 h-6" />
            </button>
            <button
              onClick={next}
              data-testid="lightbox-next"
              className="absolute right-4 top-1/2 -translate-y-1/2 z-20 w-12 h-12 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full text-white transition-colors"
              aria-label="Next"
            >
              <ChevronRight className="w-6 h-6" />
            </button>
            <img
              src={photos[index].src}
              alt={photos[index].alt}
              className="max-w-full max-h-full object-contain"
            />
            <div className="absolute bottom-6 left-6 right-6 flex items-center justify-between text-white/80 text-[11px] uppercase tracking-[0.25em]">
              <span>{photos[index].alt}</span>
              <span>
                {String(index + 1).padStart(2, "0")} /{" "}
                {String(photos.length).padStart(2, "0")}
              </span>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </section>
  );
};
